import { createReducer } from '@reduxjs/toolkit';
import { getService } from '../actions/getService';

const initialState = {
  loading: true,
  data: {},
};
export default createReducer(initialState, (builder) => {
  builder.addCase(getService.fulfilled, (state, action) => ({
    ...state,
    data: action.payload,
    loading: false,
  })).addCase(getService.pending, (state) => ({
    ...state,
    loading: true,
  })).addCase(getService.rejected, (state) => ({
    ...state,
    loading: false,
  }));
});
